import { Component, Input, Output, EventEmitter, HostListener } from "@angular/core";
import { OnInit, OnChanges, OnDestroy, DoCheck, AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { AppEditorServices } from "../../services/app-editor.services";
import { MongoImageServices } from "../../services/mongoImage.services";
import { MongoVideoServices } from "../../services/mongoVideo.services";


@Component({
  selector: 'asset-tags',
  template: require('./asset-tags.component.pug'),
  styles: [require('./asset-tags.component.scss')]
})

export class AssetTagsComponent implements OnInit, OnChanges {
  private currentAsset: any;
  private tags: any[] = new Array;

  constructor(
    private editor: AppEditorServices
  ){}

  ngOnInit(): void {}

  ngOnChanges( changes: any ): void {
    const { assets, selection } = changes;

    if ( selection ) {
      this.tags = [];
      const { currentValue } = selection;
      this.currentAsset = this.editor.getAsset( currentValue ).sort()[0];
      if ( this.currentAsset ) {
        this.tags = extractTags( this.currentAsset );
      }
    }

    if ( assets && !selection ) {
      this.tags = [];
      this.currentAsset = assets.currentValue.map( ( asset: any ) => { return (asset['_id'] === this.currentAsset['_id']) ? asset : null; }).sort()[0];
      if ( this.currentAsset ) {
        this.tags = extractTags( this.currentAsset );
      }
    }

    function extractTags( asset: any ) {
      let tags : any[] = new Array;
      const { meta, location } = asset;
      const { event, keywords, names } = meta;
      if ( location ) tags = tags.concat(setTags(location))
      if ( meta ) tags = tags.concat(setTags(meta))
      if ( event ) tags = tags.concat(setTags(event))
      return tags;
    }

    function setTags( obj: any ): any {
      let tags: any[] = new Array;
      Object.keys(obj).forEach( ( key: any )  => {
        const hit = (obj[ key ] && obj[ key ].length > 0);
        if ( hit ) {
          tags.push( key );
        }
      });
      return tags;
    }
  }

  @Input('assets') assets: any;
  @Input('selection') selection: any;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/components/asset-tags/asset-tags.component.ts